import request from '@/utils/request'

export function getAll() {
  return request({
    url: '/hc/customer/getAll',
    method: 'get'
  })
}

export function getPage(condition, pagination) {
  return request({
    url: '/hc/customer/page',
    method: 'post',
    data: { condition: condition, pagination: pagination }
  })
}

export function saveOrUpdate(data) {
  return request({
    url: '/hc/customer/saveOrUpdate',
    method: 'post',
    data
  })
}

export function get(id) {
  return request({
    url: '/hc/customer/get',
    method: 'get',
    params: { id }
  })
}

export function deleteById(id) {
  return request({
    url: '/hc/customer/deleteById',
    method: 'post',
    data: { id: id }
  })
}

export function deleteBatchByIds(ids) {
  return request({
    url: '/hc/customer/deleteBatchById',
    method: 'post',
    data: { ids: ids }
  })
}

export function exportExcel(condition, pagination) {
  return request({
    url: '/hc/customer/exportExcel',
    method: 'post',
    data: { condition: condition, pagination: pagination },
    responseType: 'blob'
  })
}

export function submit(id) {
  return request({
    url: '/hc/customer/submit',
    method: 'post',
    data: { id: id }
  })
}


export function audit(data) {
  return request({
    url: '/hc/customer/audit',
    method: 'post',
    data
  })
}